import script from "./SmallPhaseCollapseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallPhaseCollapseItem.vue?vue&type=script&setup=true&lang=js"

import "./SmallPhaseCollapseItem.vue?vue&type=style&index=0&id=029790f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-029790f0"]])

export default __exports__